import {Component, DOCUMENT, Inject, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {LANG_KEY, MYARPA_VERSION} from './shared/constants/app-constants';
import {environment} from '../environments/environment';
import {AccountService, DominioService, FamigliaStateService} from './core/service';
import {PrimeNG} from 'primeng/config';
import {TranslateService} from '@ngx-translate/core';
import {SwUpdate, VersionReadyEvent} from '@angular/service-worker';
import {filter} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DialogsUtilsService} from './core/service/utils/dialogs-utils.service';

@Component({
	selector: 'my-arp-root',
	imports: [RouterOutlet],
	template: `
    <router-outlet></router-outlet>
	`
})
export class AppComponent implements OnInit {

	title = 'my-arp@';

	constructor(private primengConfig: PrimeNG,
	            private translate: TranslateService,
	            private famigliaState: FamigliaStateService,
	            private dominioService: DominioService,
	            private accountService: AccountService,
	            private dialogUtils: DialogsUtilsService,
	            private swUpdate: SwUpdate,
	            private router: Router,
	            @Inject(DOCUMENT) private document: Document) {

		this.dominioService.clearAllCache(); // per sicurezza svuoto subito la cache nel service... (non son sicuro che serva)
		this.initLangs();
		if (this.swUpdate.isEnabled) {
			// Resta in ascolto per nuove versioni pronte
			this.swUpdate.versionUpdates.pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')).subscribe(() => {
				// forziamo l'utente a ricaricare: dialog non chiudibile con solo il bottone OK
				this.dialogUtils.openAdviseDialog(
					this.translate.instant('attenzione'),
					this.translate.instant('newVersionAvailable') + '<br>' + this.translate.instant('reloadPage'),
					'info',
					true,
					false
				).subscribe(() => window.location.reload());
			});
		}
	}

	ngOnInit() {
		this.checkMaintenanceMode();
		this.controlAppVersion();
		this.primengConfig.ripple.set(false); // niente ripple Material: look più sobrio/enterprise
		this.translate.onLangChange.subscribe((event) => {
			sessionStorage.setItem(LANG_KEY, event.lang);
			this.initPrimeNgTranslation();
			this.famigliaState.resetAllDefs(); // IMPORTANTE: reset della cache def (per nuove label relazioni/nodi)
			this.dominioService.clearAllCache(); // IMPORTANTE: reset della cache domini (verranno ricaricati con la lingua corrente..)
			this.updateHtmlLang(this.translate.currentLang);
			if (this.accountService.isAuthenticated() && !this.router.url.includes('login')) {
				// ricarico labels x soggetti terzi --> se avviene il cambio di lingua (solo se già autenticato e non sulla pagina di login)
				this.dominioService.loadAndSaveListaSoggettiTerzi();
			}
		});
	}

	initLangs() {
		const currentLang: string | null = sessionStorage.getItem(LANG_KEY);
		const browserLang = this.translate.getBrowserLang();
		const defaultLanguage = currentLang ? currentLang : (browserLang?.includes('it') ? 'it' : 'en');
		this.translate.addLangs(environment.supportedLanguages);
		this.translate.use(defaultLanguage); // applichiamo sempre la lingua di default!
	}

	// inizializza le labels di default dei componenti primeNG prendendole dalla struttura del json
	private initPrimeNgTranslation() {
		this.primengConfig.setTranslation(this.translate.instant('primeng'));
	}

	private updateHtmlLang(lang: string) {
		// 1. Aggiorna l'attributo lang (es. <html lang="en">)
		this.document.documentElement.lang = lang;
		this.document.documentElement.setAttribute('translate', 'no');
	}

	/**
	 * controllo stato BE all'avvio: se il BE è in manutenzione (503) rimando alla pagina statica di manutenzione
	 * servita da Apache (fuori dalla SPA), anche se l'utente non ha ancora effettuato nessuna chiamata autenticata.
	 * Va fatta una navigazione di pagina intera (non this.router.navigate) perché '/maintenance' non è una rotta
	 * Angular: è una risorsa statica del webserver.
	 */
	private checkMaintenanceMode() {
		this.accountService.checkAuthInfo().subscribe({
			error: (errorResponse: HttpErrorResponse) => {
				if (errorResponse.status === 503) {
					window.location.href = '/maintenance';
				}
			}
		});
	}

	/**
	 * control version app: if changed force logout
	 */
	controlAppVersion() {
		const storageVersion = localStorage.getItem(MYARPA_VERSION);
		console.log('MyArp@ v.', environment.appVersion);
		if (!storageVersion) {
			// se non c'è la versione --> la inserisco
			localStorage.setItem(MYARPA_VERSION, environment.appVersion); // setto nuova versione trovata
		} else if (storageVersion !== environment.appVersion) {
			// cambiata versione --> pulisco tutto e riparto da login
			localStorage.clear();
			sessionStorage.clear();
			localStorage.setItem(MYARPA_VERSION, environment.appVersion); // setto nuova versione trovata
			window.location.reload(); // rimanda a login
		}
	}

}
